export default __webpack_public_path__ + "static/media/vector.be6c3e2b.svg";